<template>


<div class="row"> <!-- <div class="row" v-if="$gate.isAdmin()"> -->

    <div class="toolbar py-6">
        <div class="container-fluid d-flex align-items-center">
            <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
                    <ol class="breadcrumb breadcrumb-dot text-muted fs-6 fw-semibold">
                        <li class="breadcrumb-item pe-3"><a @click="$router.go(-1)" style="cursor: pointer;" class="pe-3">Înapoi</a></li>
                        <li class="breadcrumb-item pe-3 text-muted">Listă clienti</li>
                    </ol>
                    <span class="h-20px border-gray-200 border-start mx-3"></span>
            </div>
        </div>
    </div>
		

    <div class="content d-flex flex-column flex-column-fluid">
        <div class="container-xxl">
            <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                    <div class="card-title">
                        <div class="d-flex align-items-center position-relative my-1">
                            .
                        </div>
                    </div>
                    <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
                        <div class="input-group w-250px">
                            .
                        </div>
                        <div class="w-100 mw-150px">
                            .
                        </div>
                        <a class="btn btn-primary" @click="modalAdaugareClient()">Adaugă client</a>
                    </div>
                </div>
                <div class="card-body pt-0">
                    <div id="tabel_clienti_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div class="table-responsive">
                            <table class="table table-striped table-row-bordered gy-5 gs-7" role="grid" id="tabel_clienti">
                                <thead>
                                    <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                        <th class="w-5px pe-2 sorting" rowspan="1" colspan="1" aria-label="" style="width: 10.8906px;"></th>
                                        <th class="min-w-10px sorting" tabindex="0" aria-controls="tabel_clienti" rowspan="1" colspan="1" aria-label="ID Comanda: apasa pentru sortare crescatoare">ID</th>
                                        <th class="min-w-175px sorting" tabindex="0" aria-controls="tabel_clienti" rowspan="1" colspan="1" aria-label="Client: apasa pentru sortare crescatoare">Client</th>
                                        <th class="min-w-30px sorting" tabindex="0" aria-controls="tabel_clienti" rowspan="1" colspan="1" aria-label="Stare: apasa pentru sortare crescatoare">Tip cont</th>
                                        <th class="min-w-20px sorting" tabindex="0" aria-controls="tabel_clienti" rowspan="1" colspan="1" aria-label="Data adaugarii: apasa pentru sortare crescatoare">Newsletter</th>
                                        <th class="min-w-20px sorting" tabindex="0" aria-controls="tabel_clienti" rowspan="1" colspan="1" aria-label="Data adaugarii: apasa pentru sortare crescatoare">Mail Verificat</th>
                                        <th class="min-w-20px sorting" tabindex="0" aria-controls="tabel_clienti" rowspan="1" colspan="1" aria-label="Data adaugarii: apasa pentru sortare crescatoare">Activ</th>
                                        <th class="text-end min-w-100px sorting" tabindex="0" aria-controls="tabel_clienti" rowspan="1" colspan="1" aria-label="Data modificarii: apasa pentru sortare crescatoare">Data modificarii</th>
                                        <th class="text-end min-w-100px" tabindex="0" rowspan="1" colspan="1" aria-label="Actiuni">Actiuni</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="c in clienti" :key="c.id">
                                        <td>
                                            <div class="form-check form-check-sm form-check-custom form-check-solid">
                                                <input class="form-check-input" type="checkbox" value="1">
                                            </div>
                                        </td>
                                        <td data-kt-ecommerce-order-filter="order_id">
                                            <a class="text-gray-800 text-hover-primary fw-bold">{{ c.id }}</a>
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center">
                                                <div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                                    <a href="#">
                                                        <div class="symbol-label fs-3 bg-light-warning text-warning">{{ $filters.short_hand(c.nume+' '+c.prenume) }}</div>
                                                    </a>
                                                </div>
                                                <div class="ms-5">
                                                    <div class="ml-2">		
                                                                            
                                                        <div class="text-dark-75 font-weight-bold line-height-sm">
                                                            <span class="fw-bold" v-if="c.sex == null">Nesp.</span>
                                                            <span class="fw-bold" v-if="c.sex == 1">Dl.</span>
                                                            <span class="fw-bold" v-if="c.sex == 2">Dna.</span>		
                                                            {{c.nume+' '+c.prenume }}</div>									
                                                        <a class="font-size-sm text-dark-50 text-hover-primary">{{c.email}}</a>								
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="pe-0">
                                            <div class="badge badge-success" v-if="c.tip_cont == 1">Client</div>
                                            <div class="badge badge-primary" v-if="c.tip_cont == 2">Artist</div>
                                            <div class="badge badge-info" v-if="c.tip_cont == 3">Galerie</div>
                                            <div class="badge badge-warning" v-if="c.tip_cont == 998">Administrator</div>
                                            <div class="badge badge-dark" v-if="c.tip_cont == 999">Webdev</div>
                                        </td>
                                        <td>
                                            <span class="fw-bold" v-if="c.newsletter == 0"><span class="font-weight-bold text-danger">Nu</span></span>
                                            <span class="fw-bold" v-if="c.newsletter == 1"><span class="font-weight-bold text-success">Da</span></span>
                                        </td>
                                        <td>
                                            <span class="fw-bold" v-if="c.is_email_verified == 0 && c.email_verified_at == null"><span class="font-weight-bold text-danger">Nu</span></span>
                                            <span class="fw-bold" v-if="c.is_email_verified == 1 && c.email_verified_at == null"><span class="font-weight-bold text-success">Da</span></span>
                                            <span class="fw-bold" v-if="c.is_email_verified == 0 && c.email_verified_at != null"><span class="font-weight-bold text-success">Da</span></span>
                                            <span class="fw-bold" v-if="c.is_email_verified == 1 && c.email_verified_at != null"><span class="font-weight-bold text-success">Da</span></span>
                                        </td>
                                        <td>
                                            <span class="fw-bold" v-if="c.activ == 0"><span class="font-weight-bold text-danger">Nu</span></span>
                                            <span class="fw-bold" v-if="c.activ == 1"><span class="font-weight-bold text-success">Da</span></span>
                                        </td>
                                        <td class="text-end">
                                            <span class="fw-bold" v-if="c.updated_at != null">{{ $filters.formatDate(c.updated_at) }}</span>
                                            <span class="fw-bold" v-if="c.updated_at == null">/</span>
                                        </td>
                                        <td class="text-end">
                                            <button type="button" class="btn btn-warning" @click="modalEditareClient(c)">Editare</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 


    <!-- Modal adaugare client -->
    <div class="modal fade" id="ClientModal" role="dialog" aria-labelledby="ClientModalLabel">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title" v-show="!editmode" id="ClientModalLabel">Adaugare client</h3>
              <h3 class="modal-title" v-show="editmode" id="ClientModalLabel">Editeaza client</h3>
              <!--begin::Close-->
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              <!--end::Close-->
            </div>
            <div class="modal-body">
              <form onsubmit="return false;">
                <div class="modal-body">
                  <div id="adauga_caracteristica">
                    <div class="row">
                      <!--Coloana1-->
                      <div class="col-md-6">
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.nume" class="form-control" id="nume"/>
                            <label for="nume">Nume</label>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.prenume" class="form-control" id="prenume"/>
                            <label for="prenume">Prenume</label>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.sex" class="form-control" id="sex"/>
                            <label for="sex">Sex</label>
                        </div>
                        <div class="mb-10 fv-row fv-plugins-icon-container">
                            <label class="form-label">Data nastere</label>
                            <div class="d-flex gap-3">
                                <input type="text" name="zi_nastere" v-model="form.zi_nastere" class="form-control mb-2" placeholder="ZZ">
                                <input type="text" name="luna_nastere" v-model="form.luna_nastere" class="form-control mb-2" placeholder="LL">
                                <input type="text" name="an_nastere" v-model="form.an_nastere" class="form-control mb-2" placeholder="AAAA">
                            </div>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.date_fact_preferate" class="form-control" id="date_fact_preferate"/>
                            <label for="date_fact_preferate">Date de facturare preferate</label>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.date_livrare_preferate" class="form-control" id="date_livrare_preferate"/>
                            <label for="date_livrare_preferate">Date de livrare preferate</label>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.referrer_id" class="form-control" id="referrer_id"/>
                            <label for="referrer_id">ID Referrer</label>
                        </div>
                        <div>
                            <label for="tip_cont" class="form-label">Tip cont</label>
                            <select class="form-select" v-model="form.tip_cont" id="tip_cont">
                                <option selected>Alege din lista</option>
                                <option value="1">Client</option>
                                <option value="2">Artist</option>
                                <option value="3">Galerie</option>
                                <option value="998">Administrator</option>
                            </select>
                        </div>
                        <div>
                            <label for="abonament_id" class="form-label">Tip abonament</label>
                            <select class="form-select" v-model="form.abonament_id" id="abonament_id">
                                <option selected>TBEdited</option>
                                <option value="1">Client</option>
                                <option value="2">Artist</option>
                                <option value="3">Galerie</option>
                                <option value="998">Administrator</option>
                            </select>
                        </div>
                        
                      </div>
                      <div class="col-md-6">
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.email" class="form-control" id="email"/>
                            <label for="email">E-Mail</label>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.password" class="form-control" id="password"/>
                            <label for="password">Parola</label>
                        </div>
                        <div class="form-floating mb-7">
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.email_verified_at" class="form-control" id="email_verified_at" readonly/>
                            <label for="email_verified_at">E-mail verificat la</label>
                        </div>
                        <div class="form-floating mb-7">
                            <div class="form-check form-switch">
                                <input class="form-check-input" v-model="form.is_email_verified" type="checkbox" role="switch" id="is_email_verified">
                                <label class="form-check-label" for="is_email_verified">E-Mail Verificat</label>
                            </div>
                        </div>
                        <div class="form-floating mb-7">
                            <div class="form-check form-switch">
                                <input class="form-check-input" v-model="form.newsletter" type="checkbox" role="switch" id="newsletter">
                                <label class="form-check-label" for="newsletter">Newsletter</label>
                            </div>
                        </div>
                        <div class="form-floating mb-7">
                            <div class="form-check form-switch">
                                <input class="form-check-input" v-model="form.activ" type="checkbox" role="switch" id="activ">
                                <label class="form-check-label" for="activ">Activ</label>
                            </div>
                        </div>
                        <div class="form-floating mb-7">
                            <div class="form-check form-switch">
                                <input class="form-check-input" v-model="form.reseller" type="checkbox" role="switch" id="reseller">
                                <label class="form-check-label" for="reseller">Reseller</label>
                            </div>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.ip_inregistrare" class="form-control" id="ip_inregistrare" readonly/>
                            <label for="ip_inregistrare">IP Inregistrare</label>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.last_login_at" class="form-control" id="last_login_at" readonly/>
                            <label for="last_login_at">Ultimul login</label>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.created_at" class="form-control" id="created_at" readonly/>
                            <label for="created_at">Inregistrat la</label>
                        </div>
                        <div class="form-floating mb-7">
                            <input type="text" v-model="form.updated_at" class="form-control" id="updated_at" readonly/>
                            <label for="updated_at">Actualizat la</label>
                        </div>
                        
                      </div>
                      </div>
                    </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Închide</button>
              <button @click="actualizeazaClient()" v-show="editmode" type="submit" class="btn btn-success">Modifică</button>
              <button v-show="!editmode" @click="adaugaClient()" type="submit" class="btn btn-primary">Adaugă</button>
            </div>
          </div>
        </div>
    </div>

    
</div>
</template>


<script>
    
    import moment from "moment";
    //import vue2Dropzone from 'vue2-dropzone'
    //import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    //import VueDatepickerUi from 'vue-datepicker-ui'
    //import 'vue-datepicker-ui/lib/vuedatepickerui.css';
    

    
    
    export default {
          components: {
            moment: moment,
          },
    data () {
    
    return { 

        setari_select2: {
            theme: "bootstrap",
            placeholder: "Selectează din listă",
            width: "100%",
        },

        clienti: [],
        editmode: false,

        form: Form.make({
            id: '',
            email: '',
            password: '',
            nume: '',
            prenume: '',
            sex: '',
            tip_cont: '',
            zi_nastere: '',
            luna_nastere: '',
            an_nastere: '',
            newsletter: '',
            ip_inregistrare: '',
            activ: '',
            date_fact_preferate: '',
            date_livrare_preferate: '',
            referrer_id: '',
            abonament_id: '',
            reseller: '',
            last_login_at: '',
            is_email_verified: '',
            email_verified_at: '',
            created_at: '',
            updated_at: '',
        }),
        
    }
    },
    methods:{
        incarcaClienti(){
            axios.get("/api/administrare/clienti")
            .then((response) => {
                this.clienti = response.data;
                $(document).ready( function () {
                    $('#tabel_clienti').DataTable().destroy();
                    $('#tabel_clienti').DataTable({
                        order: [[1, 'desc']], //sortare dupa rating
                        data: this.clienti,
                        dom: 'Bfrtip',
                        buttons:['disable'],
                        language: {
                            url: '//cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json'
                        }
                    });
                });
            
            });
        },
        modalAdaugareClient(){
            this.editmode = false;
            this.form.reset();
            $('#ClientModal').modal('show');
        },
        modalEditareClient(id){
            this.editmode = true;
            this.form.reset();
            this.form.fill(id);
            if(this.form.activ == 1)
            {
                this.form.activ = true;
            }
            if(this.form.reseller == 1)
            {
                this.form.reseller = true;
            }
            if(this.form.newsletter == 1)
            {
                this.form.newsletter = true;
            }
            if(this.form.is_email_verified == 1)
            {
                this.form.is_email_verified = true;
            }
            $('#ClientModal').modal('show');
        },
        adaugaClient(){
            this.$Progress.start();
            this.form.post('/api/administrare/clienti')
            .then((response)=>{
                toast.fire({
                    type: 'success',
                    icon: 'success',
                    title: 'Client adaugat!'
                })
                emitter.emit('AfterCreate');
                this.$Progress.finish();
            })
            .catch(()=>{
                this.$Progress.fail()
                toast.fire({
                    type: 'warning',
                    icon: 'warning',
                    title: 'Eroare la adăugarea clientului!'
                })
            })
        },
        actualizeazaClient(){
            this.$Progress.start();
            this.form.put('/api/administrare/clienti/'+this.form.id)
            .then(()=>{ //succes
                //$('#ClientModal').modal('hide');
                swal.fire({
                    type: 'success',
                    icon: 'success',
                    title: 'Client actualizat!',
                })
                emitter.emit('AfterCreate');
                this.$Progress.finish();
            })
            .catch(()=>{//fail
                this.$Progress.fail();
                toast.fire({
                    type: 'warning',
                    icon: 'warning',
                    title: 'Eroare la actualizarea clientului!'
                })
            });
        },
    },
    computed: {
    },
    created(){

        emitter.on('searching',() => {//search
                let query = this.$parent.search;
                axios.get('/api/utile/cautareDosare?cD=' + query)
                .then((data)=>{
                    this.dosare =data.data

                })
                .catch(()=>{
                    console.log('eroare la cautare');

                })
            })

        //var vm = this;
        this.incarcaClienti();

        emitter.on('AfterCreate',() => { 
            $('#tabel_clienti').DataTable().destroy();
            this.incarcaClienti();
        });
    },
    
    }
    </script>
    
    
    <style lang="scss" scoped>
    .icon-mare {
        font-size: 24px
    }
    
    
    </style>